import React from 'react';
import ServiceBoxRegular from '../../Shared/ServiceBox/ServiceBoxRegular/ServiceBoxRegular';
import {prepareNewWindowUrl} from '../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../Config';

const InvoicesActionsPopUp = (props) => {
  return (
    <div className='invoices-popup'>
      <div className='title-area'>
        <span>פעולות בחשבוניות</span>
      </div>
      <div
        className='actions-area'
        style={{display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: '10px', marginBottom: '3%'}}>
        {props.defaultArray != null &&
          props.defaultArray?.length > 0 &&
          props.defaultArray.map((option, index) => {
            return (
              <div className='regular-box-item'>
                <ServiceBoxRegular
                  isHaveBadge={option.isNew?.value}
                  badgeText={'חדש'}
                  backgroundImageUrl={Config.epiBaseUrl + option.actionIcon?.expandedValue?.url}
                  actionName={option.actionName?.value}
                  callback={() => prepareNewWindowUrl(option.actionUrl?.value, props.context)}></ServiceBoxRegular>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default InvoicesActionsPopUp;
